const BACKEND_DOMAIN = 'https://refugeedocsmap-api.osaarchivum.org/api/';

export const GET_COUNTRIES = BACKEND_DOMAIN + 'countries/';
export const GET_KEYWORDS = BACKEND_DOMAIN + 'keywords/';
export const GET_MOVIES = BACKEND_DOMAIN + 'films/';
export const GET_TEMPORAL_COVERAGE = BACKEND_DOMAIN + 'films/temporal_coverage';
